import axios from 'axios'
import router from '@/router'
import { uiHelper } from './ui.helper'
import Config from '@/config.json'

export function apiHelper(appendAuthHeader = true, headers = {}) {
  let baseURL = Config.VUE_APP_PRIMARY_API
  let token = uiHelper.getLocalStorage('token')
  let authHeader = token && appendAuthHeader ? { Authorization: 'Bearer ' + token } : {}
  let apiInstance = axios.create({
    baseURL,
    headers: { ...headers, ...authHeader }
  })

  const responseHandler = (response) => {
    return response.data
  }

  const errorHandler = (error) => {
    if (!error.response) {
      if (error.message === 'Network Error') {
        error.response.status = 503
        error.response.data = {
          success: false,
          code: '99',
          error: 'Network Error'
        }
        // console.log('Error 503: Network Error')
      } else {
        error.response.data = {
          success: false,
          code: '99',
          error: 'Unknown Error'
        }
      }
    }

    if (error.response.status == 401) {
      throw {
        success: false,
        code: error.response.status,
        error: error.response.data
      }
    } else {
      throw error.response.data
    }
  }

  apiInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  )

  return apiInstance
}
